<template>
    <div class="d-flex align-items-center justify-content-center vh-100 bg-light">
        <div class="col-md-4">
            <div class="text-center mb-3">
                <img src="@/assets/logo1.png" height="100" alt="Logo" loading="lazy" />
            </div>
            <div class="card shadow bg-transparent">
                <div class="card-body py-5">
                    <h2 class="text-center mb-4 text-primary">Mot de passe oublié</h2>
                    <form @submit.prevent="sendLink()">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-solid fa-user"></i>
                                </span>
                            </div>
                            <input placeholder="Email" type="email" class="form-control form-control-lg"
                                :class="{ 'is-invalid': status === false }" v-model="form.email" required
                                autocomplete="email" autofocus>
                        </div>

                        <div class="text-center">
                            <button type="submit" class="btn btn-lg btn-primary btn-block" :disabled="isLoading">
                                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                                Envoyer le lien de réinitialisation
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'ForgotPassword',
    data() {
        return {
            isLoading: false,
            form: {
                email: '',
            }
        }
    },
    methods: {
        sendLink() {
            this.isLoading = true
            this.axios.post('/api/forgot-password', this.form).then(response => {
                if (response.data.success === true) {
                    this.$router.push({ name: 'login' })
                    this.resetForm()
                }
                else {
                    this.$toast.add({
                        severity: 'warn',
                        detail: response.data.errors[0],
                        life: 5000
                    });
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {
                email: ''
            }
        }
    }
}
</script>

<style>
.login-box {
    min-width: 300px;
    max-width: 350px;
    margin: auto;
}
</style>